import { Badge } from "@/components/ui/badge/Badge";

interface ArtifactVersionBadgeProps {
  version: number;
  size?: "sm" | "md";
  className?: string;
}

/** Consistent blue version chip for artefacts, schemas, and templates. */
export function ArtifactVersionBadge({
  version,
  size = "sm",
  className,
}: ArtifactVersionBadgeProps) {
  return (
    <Badge color="sky" size={size} className={className}>
      v{version}
    </Badge>
  );
}
